<template>
  <!--问题反馈-->
  <div class="table-page-search-wrapper">
    <a-form :form="form" layout="inline">
      <a-row :gutter="6">
        <a-col :span="6">
          <a-form-item label="订单号" style="margin-left: 13px">
            <a-input v-decorator="['orderNo', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="问题类型" style="margin-left: 26px">
            <a-select v-decorator="['matterCode', { rules: [{ required: false, message: '选择' }] }]">
              <a-select-option :title="type.name" v-for="type in resTypes" :key="type.code">{{
                type.name
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!--        <a-col :span="6">-->
        <!--          <a-form-item label="处理情况" style="margin-left: 26px;">-->
        <!--            <a-select v-decorator="['handlingStatus', { rules: [{ required: false, message: '选择' }] }]" >-->
        <!--              <a-select-option title="未处理" value="0">-->
        <!--                未处理-->
        <!--              </a-select-option>-->
        <!--              <a-select-option title="处理中" value="1">-->
        <!--                处理中-->
        <!--              </a-select-option>-->
        <!--              <a-select-option title="已处理" value="2">-->
        <!--                已处理-->
        <!--              </a-select-option>-->
        <!--            </a-select>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <a-col :span="6">
          <a-form-item label="问题内容" style="margin-left: 26px">
            <a-input v-decorator="['contents', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="申请人">
            <a-input v-decorator="['initiatorName', { rules: [{ required: false, message: '请输入订单号' }] }]" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="6">
        <!--        <a-col :span="6">-->
        <!--          <a-form-item label="当前处理人">-->
        <!--            <a-input  v-decorator="['currentHandlerName', { rules: [{ required: false, message: '请输入订单号' }] }]"/>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <a-col :span="6">
          <a-form-item label="申请时间">
            <a-range-picker
              v-decorator="['datatime1']"
              :show-time="{
                hideDisabledOptions: true,
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
              }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange1"
              @ok="onOk"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <!--<a-col :span="6" v-if="manageTime">-->
        <!--<a-form-item label="开始处理时间">-->
        <!--<a-range-picker-->
        <!--v-decorator="['datatime2']"-->
        <!--:showTime="{ format: 'HH:mm:ss' }"-->
        <!--format="YYYY-MM-DD HH:mm:ss"-->
        <!--@change="onChange2"-->
        <!--@ok="onOk"-->
        <!--style="width: 100%"-->
        <!--/>-->
        <!--</a-form-item>-->
        <!--</a-col>-->

        <!--<a-col :span="6" v-if="manageTime">-->
        <!--<a-form-item label="处理完成时间">-->
        <!--<a-range-picker-->
        <!--v-decorator="['datatime3']"-->
        <!--:showTime="{ format: 'HH:mm:ss' }"-->
        <!--format="YYYY-MM-DD HH:mm:ss"-->
        <!--@change="onChange5"-->
        <!--@ok="onOk"-->
        <!--style="width: 100%"-->
        <!--/>-->
        <!--</a-form-item>-->
        <!--</a-col>-->
      </a-row>
      <!--      <a-row :gutter="6" v-if="manageTime">-->
      <!--        <a-col :span="6">-->
      <!--          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理时长">-->
      <!--            <a-row>-->
      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime1"  @keyup.native="number1"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="2">-->
      <!--                <span>至</span>-->
      <!--              </a-col>-->

      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime2" @keyup.native="number2"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="10">-->
      <!--                <a-select v-model="querytime.selectTime1"   @change="timeChange1">-->
      <!--                  <a-select-option title="选择" value=""> 选择 </a-select-option>-->
      <!--                  <a-select-option title="天" value="d"> 天 </a-select-option>-->
      <!--                  <a-select-option title="小时" value="h"> 小时 </a-select-option>-->
      <!--                </a-select>-->
      <!--              </a-col>-->
      <!--            </a-row>-->
      <!--          </a-form-item>-->
      <!--        </a-col>-->
      <!--        <a-col :span="6">-->
      <!--          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总处理时长">-->
      <!--            <a-row>-->
      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime3"  @keyup.native="number3"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="2">-->
      <!--                <span>至</span>-->
      <!--              </a-col>-->

      <!--              <a-col :span="6">-->
      <!--                <a-input v-model="querytime.textTime4" @keyup.native="number4"/>-->
      <!--              </a-col>-->
      <!--              <a-col :span="10">-->
      <!--                <a-select v-model="querytime.selectTime2"   @change="timeChange2">-->
      <!--                  <a-select-option title="选择" value=""> 选择 </a-select-option>-->
      <!--                  <a-select-option title="天" value="d"> 天 </a-select-option>-->
      <!--                  <a-select-option title="小时" value="h"> 小时 </a-select-option>-->
      <!--                </a-select>-->
      <!--              </a-col>-->
      <!--            </a-row>-->
      <!--          </a-form-item>-->
      <!--        </a-col>-->

      <!--      </a-row>-->
      <a-row :gutter="6" style="margin: 20px 0 50px 0">
        <a-col :span="16">
          <!--          <a-radio-group name="radioGroup" v-model="isMyCreate" >-->
          <!--            <a-radio :value="'0'">-->
          <!--              我的待办-->
          <!--            </a-radio>-->
          <!--            <a-radio :value="'1'">-->
          <!--              我的发起-->
          <!--            </a-radio>-->
          <!--          </a-radio-group>-->
        </a-col>
        <a-col :span="4" :offset="3">
          <span style="display: flex; justify-content: center">
            <a-button class="twobtn" style="margin-left: 20px" v-if="exportEnable" type="primary" @click="exporto()"
              >导出</a-button
            >
            <a-button class="twobtn" style="margin-left: 35px" htmlType="submit" type="primary" @click="query()"
              >查询</a-button
            >
            <a-button class="twobtn" style="margin-left: 35px" @click="restdata()">清空</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      size="default"
      ref="table"
      rowKey="modelId"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :data-source="complaintData"
      :scroll="{ x: 300 }"
      bordered
    >
      <span slot="action3" slot-scope="text, record" style="white-space: normal">
        {{ text }}
      </span>
      <span slot="action2" slot-scope="text, record">
        <a-popover title="订单子状态">
          <template slot="content">
            <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
              <p v-for="item in record.orderSubStatusList">{{ item }}</p>
            </div>
          </template>
          <a type="primary">
            {{ text }}
          </a>
        </a-popover>
      </span>
      <span slot="action" slot-scope="text, record">
        <a v-if="record.statusCode < 3" @click="handles(record)">处理<a-divider type="vertical" /></a>

        <a v-if="record.statusCode < 2 && dispatchEnable" @click="Transfer(record)"
          >转派 <a-divider type="vertical"
        /></a>

        <a-popover trigger="click" title="履历">
          <template slot="content">
            <div style="overflow-y: auto; max-height: 250px; padding-right: 20px">
              <div v-for="item in dataResume">
                <p>履历内容:{{ item.content }}</p>
                <p>操作人姓名:{{ item.createName }}</p>
                <p>操作时间:{{ item.createTime }}</p>
                <a-divider type="vertical" />
              </div>
            </div>
          </template>
          <a @click="Resume(record)" v-if="recodeEnable"> 履历 </a>
        </a-popover>

        <a v-if="record.handleStartTimeStart == ''" @click="withdraw(record)"> <a-divider type="vertical" />撤回</a>
      </span>
    </a-table>
    <a-pagination
      show-size-changer
      show-quick-jumper
      :default-current="1"
      :total="total"
      @change="onChangePage"
      @showSizeChange="onShowSizeChange"
      style="float: right; margin: 30px 10px 10px 0"
    />
    <!--转派弹框-->
    <a-modal
      title="转派"
      :width="800"
      v-model="visible2"
      :confirmLoading="confirmLoading2"
      @ok="handleSubmit2"
      :closable="false"
      :maskClosable="false"
    >
      <a-form :form="form2" layout="inline">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="转派角色">
              <a-select
                v-decorator="['roleCode', { rules: [{ required: false, message: '选择' }] }]"
                style="width: 300px"
              >
                <a-select-option v-for="type in Roledata" :key="type.code">{{ type.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <enterprise-details ref="details" @ok="handleOk" />
    <masterlist-edit ref="Mastermodal" @ok="handleOk"></masterlist-edit>
    <edit-order-model v-if="$store.state.user_type == 1" ref="editorder" @ok="handleOk"></edit-order-model>
    <edit-order-model1 v-else ref="editorder" @ok="handleOk"></edit-order-model1>
    <leaflets-distribute-model ref="leaflets" @ok="handleOk"></leaflets-distribute-model>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { checkPermission } from '@/utils/permissions'
import moment from 'moment'
export default {
  name: 'Problem',
  components: {
    EnterpriseDetails: () => import('@/views/enterprise/EnterpriseDetails'),
    MasterlistEdit: () => import('@/views/master/modules/MasterlistEdit'),
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    leafletsDistributeModel: () => import('@/views/order/modules/leafletsDistributeModel'),
  },
  data() {
    return {
      batchEnable: checkPermission('toDo:batch'), //批量处理
      exportEnable: checkPermission('toDo:export'), //导出
      dispatchEnable: checkPermission('toDo:dispatch'), //转派
      recodeEnable: checkPermission('toDo:recode'), //履历
      manageTime: checkPermission('manageTime'),
      form: this.$form.createForm(this),
      queryParam: {},
      visible: false,
      confirmLoading: false,
      visible2: false,
      confirmLoading2: false,
      form2: this.$form.createForm(this),
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          width: '70px',
          align: 'center',
        },
        {
          title: '操作',
          width: '40px',
          dataIndex: 'statusArea',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '处理情况',
          dataIndex: 'handlingStatus',
          align: 'center',
        },
        {
          title: '问题类型',
          dataIndex: 'matterName',
          align: 'center',
        },
        {
          title: '问题内容',
          dataIndex: 'contents',
          scopedSlots: { customRender: 'action3' },
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },

        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatusName',
          align: 'center',
          scopedSlots: { customRender: 'action2' },
        },
        {
          title: '申请人',
          dataIndex: 'initiatorName',
          align: 'center',
        },
        {
          title: '申请人联系方式',
          dataIndex: 'initiatorPhone',
          align: 'center',
        },

        {
          title: '问题反馈时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipalName',
          align: 'center',
        },
        {
          title: '安装类型名称',
          dataIndex: 'installTypeName',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '客户电话',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipalName',
          align: 'center',
        },
        // {
        //   title: '当前协助人',
        //   dataIndex: 'helperName',
        //   align:'center'
        // },
        // {
        //   title: '师傅姓名',
        //   dataIndex: 'workName',
        //   align:'center'
        // },
        // {
        //   title: '师傅联系方式',
        //   dataIndex: 'workPhone',
        //   align:'center'
        // },
        // {
        //   title: '师傅负责人姓名',
        //   dataIndex: 'masterLeadingName',
        //   align:'center'
        // },
        // {
        //   title: '当前处理人姓名',
        //   dataIndex: 'currentHandlerName',
        //   align:'center'
        // },
        // {
        //   title: '处理时长',
        //   dataIndex: 'processingTimeInfo',
        //   align:'center'
        // },
        // {
        //   title: '开始处理时间',
        //   dataIndex: 'handleStartTime',
        //   align:'center'
        // },
        // {
        //   title: '处理完成时间',
        //   dataIndex: 'handleEndTime',
        //   align:'center'
        // },
        // {
        //   title: '总处理时长',
        //   dataIndex: 'totalProcessingTimeInfo',
        //   align:'center'
        // }
      ],
      pagination: false,
      loading: true,
      complaintData: [],
      querytime: {},
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      isMyOrder: false,
      resTypes: [],
      isMyCreate: '0',
      feedbackHeaderId: '',
      Roledata: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      dataResume: [],
    }
  },
  methods: {
    moment,
    //查询参数
    Biography(values) {
      values.isMyCreate = this.isMyCreate
      values.pageSize = this.pageSize
      values.pageNum = this.pageNum
      values.complaintTimeStart = this.querytime.complaintTimeStart
      values.complaintTimeEnd = this.querytime.complaintTimeEnd
      values.handleStartTimeStart = this.querytime.handleStartTimeStart
      values.handleStartTimeEnd = this.querytime.handleStartTimeEnd
      values.handleEndTimeStart = this.querytime.handleEndTimeStart
      values.handleEndTimeEnd = this.querytime.handleEndTimeEnd
      values.processingTimeStart = this.querytime.textTime1
      values.processingTimeEnd = this.querytime.textTime2
      values.processingTimeType = this.querytime.selectTime1
      values.totalProcessingTimeStart = this.querytime.textTime3
      values.totalProcessingTimeEnd = this.querytime.textTime4
      values.totalProcessingTimeType = this.querytime.selectTime2
      delete values.datatime3
      delete values.datatime1
      delete values.datatime2
      return values
    },
    //导出
    exporto() {
      this.form.validateFields((err, values) => {
        var str = process.env.VUE_APP_API_BASE_URL + '/backlog/feedback/export?pageSize=10&pageNum=1'

        var arrStr = this.Biography(values)
        for (let i in arrStr) {
          if (arrStr[i] != undefined) {
            str = str + '&' + i + '=' + arrStr[i]
          }
        }
        str = str + '&token=' + this.headers.token
        window.open(str)

        // this.$axios({
        //   method: "get",
        //   url: "/api/backlog/feedback/export",
        //   params:this.Biography(values),
        //   responseType: 'arraybuffer',
        //   headers: {
        //     token: Vue.ls.get(ACCESS_TOKEN),
        //     'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //   }
        // }).then((res) => {
        //   const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //   const a = document.createElement('a')
        //   // 生成文件路径
        //   let href = window.URL.createObjectURL(blob)
        //   a.href = href
        //   let fileName = '问题反馈'
        //   // 文件名中有中文 则对文件名进行转码
        //   a.download = decodeURIComponent(fileName)
        //   // 利用a标签做下载
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //   window.URL.revokeObjectURL(href)
        // })
      })
    },
    //履历
    Resume(values) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersResume',
        params: {
          pendingMattersRecordId: values.feedbackHeaderId,
          matterCode: values.matterCode,
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.dataResume = res.data.data
      })
      // /pendingMatter/getPendingMattersResume
    },

    //分页
    onChangePage(pageNumber) {
      this.pageNum = pageNumber
      this.query()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.pageNum = current
      this.query()
    },
    //撤回
    withdraw(value) {
      console.log(value)
      this.$axios({
        method: 'post',
        url: '/api/backlog/feedback/revoke',
        params: {
          feedbackHeaderId: value.feedbackHeaderId,
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        console.log(res)
        if (res.data.code == 0) {
          this.$message.success('问题反馈撤销成功')
          this.query()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //时间区间
    timeChange1(value) {
      console.log(value)
      this.querytime.selectTime1 = value
    },
    timeChange2(value) {
      this.querytime.selectTime2 = value
    },
    number1() {
      this.regular(this.querytime.textTime1)
    },
    number2() {
      this.regular(this.querytime.textTime2)
    },
    number3() {
      this.regular(this.querytime.textTime3)
    },
    number4() {
      this.regular(this.querytime.textTime4)
    },
    regular(value) {
      value = value.replace(/[^\.\d]/g, '')
      value = value.replace('.', '')
    },
    //处理
    handles(value) {
      console.log(value)
      if (value.jumpUrl === 'orderInfo') {
        //订单详情
        // this.$router.push({path:'/order/orderList', query:{orderNo: value.orderNo}})
        // this.$emit('Ok')
        this.$refs.editorder.showeditOrder(value.orderId, 1, 1, '', value.auditStatus, '', 2)
      } else if (value.jumpUrl === 'orderChangePrice') {
        //订单改价处
        let that = this
        this.$refs.editorder.showeditOrder(value.orderId, 2, 1, '', value.auditStatus, '', 2)
        setTimeout(function () {
          that.$refs.editorder.changePrice()
        }, 1000)
      } else if (value.jumpUrl === 'enterprisePriceInfo') {
        //企业详情-金额信息
        this.$refs.details.edit(value.enterpriseId, '2', 1, 0)
      } else if (value.jumpUrl === 'masterPrice') {
        //师傅详情-金额信息
        value.userId = value.masterId
        this.$refs.Mastermodal.edit(value, '2', 1, 0)
      } else if (value.jumpUrl === 'changeDispatch') {
        //派单页面
        this.$axios({
          method: 'get',
          url: '/api/order/DispatchOrder/orderInfo',
          params: { orderId: value.orderId },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }).then((res) => {
          if (res.data.code === 0) {
            this.$refs.leaflets.showleaflets(res.data.data)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    restdata() {
      this.isMyCreate = '0'
      this.form.resetFields()
      this.querytime = {}
      this.query()
    },
    handleOk() {
      this.query()
    },
    // 请求表格数据
    dataList(data) {
      this.$axios({
        method: 'get',
        url: '/api/backlog/feedback/getFeedbackList',
        params: data,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.loading = false
        this.complaintData = res.data.rows
        this.total = res.data.total
        this.$emit('Ok')
      })
    },
    //查询
    query() {
      this.form.validateFields((err, values) => {
        if (this.isMyCreate == 1) {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center',
            },
            {
              title: '处理情况',
              dataIndex: 'handlingStatus',
              align: 'center',
            },
            {
              title: '问题类型',
              dataIndex: 'matterName',
              align: 'center',
            },
            {
              title: '问题内容',
              dataIndex: 'contents',
              scopedSlots: { customRender: 'action3' },
            },
            {
              title: '订单号',
              dataIndex: 'orderNo',
              align: 'center',
            },
            {
              title: '锁企简称',
              dataIndex: 'enterpriseName',
              align: 'center',
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center',
            },
            {
              title: '订单子状态',
              dataIndex: 'orderSubStatusName',
              align: 'center',
              scopedSlots: { customRender: 'action2' },
            },
            {
              title: '申请人',
              dataIndex: 'initiatorName',
              align: 'center',
            },
            {
              title: '申请人联系方式',
              dataIndex: 'initiatorPhone',
              align: 'center',
            },
            {
              title: '问题反馈时间',
              dataIndex: 'createTime',
              align: 'center',
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipalName',
              align: 'center',
            },
            {
              title: '安装类型名称',
              dataIndex: 'installTypeName',
              align: 'center',
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center',
            },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center',
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center',
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center',
            },
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            // {
            //   title: '师傅姓名',
            //   dataIndex: 'workName',
            //   align:'center'
            // },
            // {
            //   title: '师傅联系方式',
            //   dataIndex: 'workPhone',
            //   align:'center'
            // },
            // {
            //   title: '师傅负责人姓名',
            //   dataIndex: 'masterLeadingName',
            //   align:'center'
            // },
            // {
            //   title: '当前处理人姓名',
            //   dataIndex: 'currentHandlerName',
            //   align:'center'
            // },
            // {
            //   title: '处理时长',
            //   dataIndex: 'processingTimeInfo',
            //   align:'center'
            // },
            // {
            //   title: '开始处理时间',
            //   dataIndex: 'handleStartTime',
            //   align:'center'
            // },
            // {
            //   title: '处理完成时间',
            //   dataIndex: 'handleEndTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // }
          ]
        } else {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'no',
              width: '70px',
              align: 'center',
            },
            {
              title: '操作',
              width: '40px',
              dataIndex: 'statusArea',
              scopedSlots: { customRender: 'action' },
            },
            {
              title: '处理情况',
              dataIndex: 'handlingStatus',
              align: 'center',
            },
            {
              title: '问题类型',
              dataIndex: 'matterName',
              align: 'center',
            },
            {
              title: '问题内容',
              dataIndex: 'contents',
              scopedSlots: { customRender: 'action3' },
            },
            {
              title: '订单号',
              dataIndex: 'orderNo',
              align: 'center',
            },
            {
              title: '锁企简称',
              dataIndex: 'enterpriseName',
              align: 'center',
            },
            {
              title: '订单状态',
              dataIndex: 'orderStatusName',
              align: 'center',
            },
            {
              title: '订单子状态',
              dataIndex: 'orderSubStatusName',
              align: 'center',
              scopedSlots: { customRender: 'action2' },
            },
            {
              title: '申请人',
              dataIndex: 'initiatorName',
              align: 'center',
            },
            {
              title: '申请人联系方式',
              dataIndex: 'initiatorPhone',
              align: 'center',
            },
            {
              title: '问题反馈时间',
              dataIndex: 'createTime',
              align: 'center',
            },
            {
              title: '市场负责人',
              dataIndex: 'marketPrincipalName',
              align: 'center',
            },
            {
              title: '安装类型名称',
              dataIndex: 'installTypeName',
              align: 'center',
            },
            {
              title: '订单类型',
              dataIndex: 'orderTypeName',
              align: 'center',
            },
            {
              title: '客户姓名',
              dataIndex: 'clientName',
              align: 'center',
            },
            {
              title: '客户电话',
              dataIndex: 'clientPhone',
              align: 'center',
            },
            {
              title: '订单负责人',
              dataIndex: 'orderPrincipalName',
              align: 'center',
            },
            // {
            //   title: '当前协助人',
            //   dataIndex: 'helperName',
            //   align:'center'
            // },
            // {
            //   title: '师傅姓名',
            //   dataIndex: 'workName',
            //   align:'center'
            // },
            // {
            //   title: '师傅联系方式',
            //   dataIndex: 'workPhone',
            //   align:'center'
            // },
            // {
            //   title: '师傅负责人姓名',
            //   dataIndex: 'masterLeadingName',
            //   align:'center'
            // },
            // {
            //   title: '当前处理人姓名',
            //   dataIndex: 'currentHandlerName',
            //   align:'center'
            // },
            // {
            //   title: '处理时长',
            //   dataIndex: 'processingTimeInfo',
            //   align:'center'
            // },
            // {
            //   title: '开始处理时间',
            //   dataIndex: 'handleStartTime',
            //   align:'center'
            // },
            // {
            //   title: '处理完成时间',
            //   dataIndex: 'handleEndTime',
            //   align:'center'
            // },
            // {
            //   title: '总处理时长',
            //   dataIndex: 'totalProcessingTimeInfo',
            //   align:'center'
            // }
          ]
        }
        this.dataList(this.Biography(values))
      })
    },
    //转派
    Transfer(value) {
      this.feedbackHeaderId = value.feedbackHeaderId
      this.visible2 = true
      //获取转派角色列表
      this.$axios({
        method: 'get',
        url: '/api/backlog/pendingMatter/getPendingMattersRoleList',
        params: {
          type: '',
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.Roledata = res.data.data
      })
    },
    //申请时间
    onChange1(date, dateString) {
      console.log(dateString[0], dateString[1])
      this.querytime.createTimeStart = dateString[0]
      this.querytime.createTimeEnd = dateString[1]
    },
    //开始处理时间
    onChange2(date, dateString) {
      this.querytime.handleStartTimeStart = dateString[0]
      this.querytime.handleStartTimeEnd = dateString[1]
    },
    //处理完成时间
    onChange5(date, dateString) {
      this.querytime.handleEndTimeStart = dateString[0]
      this.querytime.handleEndTimeEnd = dateString[1]
    },
    //转派提交
    handleSubmit2() {
      this.form2.validateFields((err, values) => {
        this.$axios({
          method: 'post',
          url: '/api/backlog/feedback/transfer',
          params: {
            feedbackHeaderId: this.feedbackHeaderId,
            roleCode: values.roleCode,
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('转派成功')
            this.visible2 = false
            this.query()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
  },
  created() {
    //获取问题类型下拉框
    this.$axios({
      method: 'get',
      url: '/api/backlog/pendingMatter/getPendingMatterMenu',
      params: {
        matterTypeCode: 'feedback',
      },
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
        'Content-Type': 'application/json;charset=UTF-8',
      },
    }).then((res) => {
      this.resTypes = res.data.data
      // console.log(res.data.data,'获取投诉类型下拉框')
    })
    // if(!this.manageTime){
    //   var newarry=[]
    //   var titlearry=['处理时长', '总处理时长','开始处理时间','处理完成时间']
    //   for(let i in this.columns){
    //     if(titlearry.indexOf(this.columns[i].title)==-1){
    //       newarry.push(this.columns[i])
    //     }
    //   }
    //   this.columns=newarry
    // }
  },
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>